/**
 * en-GB messages added by Phase 4 task S44 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s44EnGB = {
    'error.api_range_too_long': 'Ask for no more than 93 days at a time.',
    'error.visit_legal_hold': 'This visit is under a legal hold, so its protection cannot be removed here. Release the hold in Data protection first.',
    'dp.visits.visits': 'Visits',
    'dp.visits.answers': 'Answers given at sign-in and sign-out',
    'dp.visits.notes': 'Notes on visits',
    'dp.visits.kiosk_events': 'Kiosk sign-in and sign-out records',
};
//# sourceMappingURL=s44.js.map